define('controller/template/template.preview.controller',['require','exports','module','underscore','fukit','view/template/template.preview.page.view','formkit/formkit','model/revision.model','model/template.preview.model','backbone.radio','fukit'],function(require, exports, module) {
  //prettier-ignore
  var  _                   = require('underscore'),
      Base                 = require('fukit').BaseController,
      RevisionPreviewPage  = require('view/template/template.preview.page.view'),
      FormKit              = require('formkit/formkit'),
      RevisionModel        = require('model/revision.model'),
      TemplatePreviewModel = require('model/template.preview.model'),
      Radio                = require('backbone.radio'),
      ROLES                = require('fukit').Roles;

  var TemplatePreviewController = Base.extend({
    radioRequests: {
      'controllers TemplatePreviewController': '@constructor',
    },

    pageView: RevisionPreviewPage,

    pageViewOptions: function() {
      return {
        form: this.createForm(),
      };
    },

    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
        previewMode: true,
      },
    },

    resources: {
      template: {
        model: TemplatePreviewModel,
      },
      revision: {
        model: RevisionModel,
        attrs: {
          id: '@state.revisionId',
        },
      },
      latestRevisionCollection: {
        collection: RevisionModel.Collection,
        filters: [
          {
            field: 'template.id',
            value: '@state.templateId',
          },
          {
            field: 'publishedDate',
            operation: '$',
          },
        ],
      },
    },

    createForm: function() {
      var template = this.getResource('template');

      var form = new FormKit.Form({
        templateModel: template,
      });

      this.listenTo(
        form,
        'end:edit:answer',
        _.debounce(function() {
          template.save();
        })
      );

      return form;
    },

    onStart: function() {
      var revisionModel = this.getResource('revision');
      var latestRevisionCollection = this.getResource('latestRevisionCollection');

      if (revisionModel.isNew()) {
        this.listenToOnce(latestRevisionCollection, 'sync', function() {
          if (!latestRevisionCollection.isEmpty()) {
            var revisionId = latestRevisionCollection.first().id;
            this.state.set('revisionId', revisionId);
            revisionModel.set('id', revisionId);
            revisionModel.fetch();
          }
        });
        latestRevisionCollection.fetch();
      } else {
        revisionModel.fetch();
      }

      this.listenTo(this.getResource('revision'), 'sync', this.onRevisionResourceSync);
    },

    onRevisionResourceSync: function(model, resp, options) {
      var revisionModel = this.getResource('revision');
      var templateModel = this.getResource('template');
      templateModel.set(revisionModel.get('json'));
      templateModel.save();
    },
  });
  module.exports = TemplatePreviewController;
});

